import { SubTitleParagraph } from "styles/jss/Layout.styles";

export default function MainSubTitle({
  children,
  className,
  textAlign,
  color,
}) {
  return (
    <SubTitleParagraph
      className={className}
      textAlign={textAlign}
      color={color}
    >
      {children}
    </SubTitleParagraph>
  );
}
